var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonicMdHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.75,
    height: 21,
    viewBox: "0 0 22.75 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-home",
    "data-name": "Icon ionic-md-home",
    d: "M12.125,25.5v-7h5.25v7h5.337V15h3.413L14.75,4.5,3.375,15H6.787V25.5Z",
    transform: "translate(-3.375 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicMdHome);
export default __webpack_public_path__ + "static/media/ionic-md-home.4310203073638215d76874050593fd77.svg";
export { ForwardRef as ReactComponent };